<template>
  <div>
    <!-- Navbar -->
    <div class="row">
      <div class="col-12 col-lg-2">
        <!-- Sidebar -->
        <nav id="sidebarMenu" class="collapse d-block sidebar bg-white pt-5">
          <div class="sidebar-sticky">
            <KTBrand></KTBrand>
            <!-- <b-button
              variant="link"
              class="my-1 text-center"
              @click="goToSimulationLink"
              block
              >{{ $t("virtual_pos_api_doc.simulation_link") }}</b-button
            > -->
            <div class="list-group list-group-flush mx-3 mt-4 overflow-hidden">
              <div
                v-for="(tab, tabIdx) in miracleCustomerSideTabs"
                :key="`miracleCustomerSideTab-${tabIdx}`"
                class="d-flex flex-column"
              >
                <button
                  @click="tab.onClick"
                  class="list-group-item list-group-item-action py-2 ripple"
                  aria-current="true"
                >
                  <i :class="tab.icon"></i>
                  <span class="ml-2">{{ tab.label }}</span>
                </button>
                <button
                  v-for="(subTab, tabIdx) in tab.subs"
                  :key="`miracleCustomerSideTab-sub-${tabIdx}`"
                  @click="subTab.onClick"
                  class="list-group-item list-group-item-action border-0 py-2 ml-4"
                  aria-current="true"
                >
                  <div class="ml-2" v-html="subTab.label"></div>
                </button>
              </div>
            </div>
          </div>
        </nav>
        <!-- Sidebar -->
      </div>
      <div class="col-12 col-lg-10">
        <div class="d-flex py-5 px-5 px-md-2 flex-row rounded">
          <div class="flex-column d-flex">
            <label>{{ $t("virtual_pos_api_doc.customer") }}</label>
            <b-dropdown
              size="sm"
              :text="getCustomerDropdownText()"
              variant="outline-primary"
            >
              <b-dropdown-item-button
                @click="isMiracleCustomer = true"
                :key="'MIRACLE_CUSTOMER'"
              >
                <span class="d-inline-flex align-items-center">
                  <b-icon
                    v-if="isMiracleCustomer"
                    icon="check"
                    font-scale="1.5"
                    class="mr-1"
                    variant="success"
                  ></b-icon>
                  {{
                    $t(
                      "PAGES.SALES_MANAGEMENT.QR_SALE.NEW_SALE_WITH_QR_CODE.MIRACLE_CUSTOMER"
                    )
                  }}
                </span>
              </b-dropdown-item-button>
              <b-dropdown-item-button
                @click="isMiracleCustomer = false"
                :key="'NOT_MIRACLE_CUSTOMER'"
              >
                <span class="d-inline-flex align-items-center">
                  <b-icon
                    v-if="!isMiracleCustomer"
                    icon="check"
                    font-scale="1.5"
                    class="mr-1"
                    variant="success"
                  ></b-icon>
                  {{
                    $t(
                      "PAGES.SALES_MANAGEMENT.QR_SALE.NEW_SALE_WITH_QR_CODE.NOT_MIRACLE_CUSTOMER"
                    )
                  }}
                </span>
              </b-dropdown-item-button>
            </b-dropdown>
          </div>
          <div class="flex-column d-flex ml-2">
            <label>Environment</label>
            <b-dropdown
              size="sm"
              :text="getEnvDropdownText()"
              variant="outline-primary"
            >
              <b-dropdown-item-button @click="onChangeEnv(true)" :key="'dev'">
                <span class="d-inline-flex align-items-center">
                  <b-icon
                    v-if="isDev"
                    icon="check"
                    font-scale="1.5"
                    class="mr-1"
                    variant="success"
                  ></b-icon>
                  Development
                </span>
              </b-dropdown-item-button>
              <b-dropdown-item-button @click="onChangeEnv(false)" :key="'prod'">
                <span class="d-inline-flex align-items-center">
                  <b-icon
                    v-if="!isDev"
                    icon="check"
                    font-scale="1.5"
                    class="mr-1"
                    variant="success"
                  ></b-icon>
                  Production
                </span>
              </b-dropdown-item-button>
            </b-dropdown>
          </div>
        </div>
        <div class="bg-secondary p-10" id="intro">
          <h1>{{ $t("virtual_pos_api_doc.intro") }}</h1>
          <p
            v-html="$t('virtual_pos_api_doc.intro_desc')"
            v-if="isMiracleCustomer"
          ></p>
          <p
            v-html="$t('virtual_pos_api_doc.intro_non_miracle_customer_desc')"
            v-else
          ></p>
          <div class="mt-20">
            <h3>{{ $t("virtual_pos_api_doc.example") }}:</h3>
            <div class="row">
              <img :src="res1" alt="res1" class="w-100 h-75 mb-3" />
            </div>
            <div class="row">
              <img :src="res2" alt="res2" class="w-100 h-75 mb-3" />
            </div>
            <div class="row">
              <img :src="res3" alt="res3" class="w-100 h-75 mb-3" />
            </div>
            <div class="row" v-if="isMiracleCustomer">
              <img :src="res4" alt="res4" class="w-100 h-75 mb-3" />
            </div>
            <div class="row" v-if="!isMiracleCustomer">
              <img :src="res5" alt="res5" class="w-100 h-75 mb-3" />
            </div>
            <div class="row" v-if="!isMiracleCustomer">
              <img :src="res6" alt="res6" class="w-100 h-75" />
            </div>
          </div>
        </div>
        <div class="row p-5">
          <div class="col-sm-12  mt-40 bg-secondary p-10" id="auth">
            <div class="col-sm-12"><h1>Authentication</h1></div>
            <div class="row">
              <div class="col-12">
                <h3>
                  <small
                    >POST-- {{ $t("virtual_pos_api_doc.auth_desc") }}:
                  </small>
                  {{ `${mpayBaseUrl}authentication_token` }}
                </h3>
              </div>
              <pre class="col-12 code text-white">
                Request Body
                {{
                  `
                  {
                    "email": "test@test.com",
                    "password": "000000"
                  }
                  `
                }}
              </pre>
              <pre class="col-12 code mt-2 text-white">
                Response
                {{
                  `
                  {
                    "token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9...."
                  }
                  `
                }}
              </pre>
            </div>
          </div>
          <div class="col-sm-12  mt-40 bg-secondary p-10" id="createOrder">
            <div class="col-sm-12">
              <h1>{{ $t("virtual_pos_api_doc.create_order") }}</h1>
            </div>
            <div>
              <div class="col-12">
                <h3>
                  <small
                    >POST-- {{ $t("virtual_pos_api_doc.create_order_desc") }}:
                  </small>
                  {{ `${mpayApiBaseUrl}company-orders` }}
                </h3>
              </div>
              <pre class="col-12 code text-white">
                Request Body
                {{
                  `
                  {
                    "customerMail":"",
                    "customerName":"",
                    "customerPhone":"",
                    "price":"22",
                    "feeIncluded": true | false, // if true the BRANCH will pay the commission else the CUSTOMER
                    "devicesId": 2
                  }
                  `
                }}
              </pre>
              <pre class="col-12 code mt-2 text-white">
                Response
                {{
                  `
                  {
                    amount: null,
                    createdAt: "2022-07-12T11:34:27+00:00"
                    customerMail: ""
                    customerName: "",
                    customerPhone: "",
                    fee: "5.00",
                    feeIncluded: false,
                    id: 1160,
                    merchantId: 3,
                    nexusAmount: null,
                    orderNumber: "20220712C740386C5FB5",
                    orderStatus: "pending",
                    paymentUnit: null,
                    paymentUnitName: null,
                    platform: null,
                    price: "22.00",
                    selectedCryptoCurrencyBuying: null,
                    selectedCurrencyBuying: null,
                    status: 0,
                    updatedAt:
                    "2022-07-12T11:34:27+00:00"
                  }
                  `
                }}
              </pre>
            </div>
          </div>
          <div class="col-sm-12  mt-40 bg-secondary p-10" id="getCompanyOrder">
            <div class="col-sm-12">
              <h1>{{ $t("virtual_pos_api_doc.get_company_order") }}</h1>
            </div>
            <div>
              <div class="col-12">
                <h3>
                  <small
                    >GET--
                    {{ $t("virtual_pos_api_doc.get_company_order_desc") }}:
                  </small>
                  {{
                    `${mpayApiBaseUrl}company-order-number?orderNumber={orderNumber}`
                  }}
                </h3>
              </div>
              <pre class="col-12 code mt-2 text-white">
                Response
                {{
                  `
                  {
                    "id": 2603,
                    "selectedCurrencyId": 6,
                    "selectedCurrencyCode": "ETH",
                    "price": "10.00",
                    "fee": "5.00",
                    "feeIncluded": false,
                    "customerName": "",
                    "customerMail": "",
                    "customerPhone": "",
                    "status": 13,
                    "orderNumber": "2024110773F93109BB33",
                    "amount": 0.00390769,
                    "platform": "Other",
                    "nexusAmount": 0.00380769,
                    "paymentUnit": {
                        "id": 1,
                        "name": "USD"
                    },
                    "selectedCurrencyBuying": null,
                    "selectedCryptoCurrencyBuying": null,
                    "nexusAmountConvertCurrency": 10.23,
                    "paymentState": "\/api\/payment-states\/1",
                    "feeAmount": 0.5,
                    "orderTotal": 10.5,
                    "commissionConvertCurrency": 0.00018608,
                    "sourceAddress": null,
                    "txHash": "0xea281185d3219018d024a709f789b801ea86cafdfd7368c48c1fb6e28a259634",
                    "device": "\/api\/devices\/3",
                    "fiat": true,
                    "commissionStatus": null,
                    "diffAmount": "0.0001000000",
                    "diffPrice": 0.27,
                    "createdAt": "2024-11-07T16:36:34+00:00",
                    "updatedAt": "2024-11-07T16:41:57+00:00",
                    "orderStatus": "underpaymentCompleted",
                    "branchTitle": "other branch",
                    "merchantId": 136,
                    "merchantName": "Test Merchant A.\u015e.",
                    "paymentUnitName": "USD",
                    "paymentStateId": 1,
                    "paymentStateName": "onstandby",
                    "responsibleAdminId": 1,
                    "deviceShort": "pnl",
                    "merchantFiat": true
                  }
                  `
                }}
              </pre>
            </div>
          </div>
          <div class="col-sm-12  mt-40 bg-secondary p-10" id="convert">
            <div class="col-sm-12">
              <h1>{{ $t("virtual_pos_api_doc.convert") }}</h1>
            </div>
            <div>
              <div class="col-12">
                <h3>
                  <small
                    >POST-- {{ $t("virtual_pos_api_doc.convert_desc") }}:
                  </small>
                  {{ `${ofinansApiBaseUrl}miraclepay/convert-test` }}
                </h3>
              </div>
              <pre class="col-12 code text-white">
                Request Body
                {{
                  `
                  {
                    "currency":"usd",
                    "crypto":"eth",
                    "amount":100
                  }
                  `
                }}
              </pre>
              <pre class="col-12 code mt-2 text-white">
                Response
                {{
                  `
                  {
                    "success": "ok",
                    "crypto_amount": 0.01435609,
                    "currency": "USD",
                    "crypto_code": "ETH",
                    "message": "your transaction was successfully"
                  }
                  `
                }}
              </pre>
            </div>
          </div>
          <div class="col-sm-12  mt-40 bg-secondary p-10" id="payment_stage">
            <div class="col-sm-12">
              <h1>{{ $t("virtual_pos_api_doc.payment_stage") }}</h1>
            </div>
            <div>
              <div class="col-12 text-break">
                <h3>
                  <small
                    >{{ isMiracleCustomer ? "POST" : "GET" }}--
                    {{ $t("virtual_pos_api_doc.payment_stage_desc") }}:</small
                  >
                  {{
                    isMiracleCustomer
                      ? `${mpayApiBaseUrl}company-orders/{orderId}/transactions/qr-sale`
                      : `${mpayApiBaseUrl}nexus/create_payment/{crypto}/{orderId}/{paymentUnit}`
                  }}
                  <template v-if="!isMiracleCustomer">
                    <p class="mt-2">crypto: <strong>btc,eth</strong>,...</p>
                    <p>paymentUnit: <strong>usdt,try,eur</strong>,...</p>
                  </template>
                </h3>
                <p v-html="$t('virtual_pos_api_doc.payment_stage_desc_2')"></p>
              </div>
              <pre class="col-12 text-white code" v-if="isMiracleCustomer">
                Request Body
                {{
                  `
                  {
                    "hash":"a35ed7fc45142b68b2d46a4f39916...",
                    "selectedCurrencyCode":"ETH",
                    "selectedCurrencyId":2,
                    "selectedPaymentName":"usd"
                  }
                  `
                }}
              </pre>
              <pre class="col-12 text-white code mt-2" v-if="isMiracleCustomer">
                Response
                {{
                  `
                    {
                        "status": 200,
                        "content": {
                            "success": "ok",
                            "transaction_id": 293,
                            "cyrpto_amount": 0.00066117,
                            "currency": "USD",
                            "cyrpto": "BTC",
                            "message": "your transaction was successfully",
                            "user": {
                                "id": 123456,
                                "affiliate_id": null,
                                "name": "User",
                                ..
                            }
                        }
                    }
                    `
                }}
              </pre>
              <pre class="col-12 text-white code mt-2" v-else>
                Response
                {{
                  `
                  {
                      "address": "0x4F1EE081cf92699b011eA7E0583395671f46e4f8",
                      "walletNetwork": {
                        "id": 136,
                        "name": "Ethereum",
                        "code": "ETH",
                        "currency_id": 6,
                        "asset_id": 12,
                        "created_at": "2023-05-07T14:32:09.000000Z",
                        "updated_at": "2023-05-07T14:32:09.000000Z"
                      }
                  }
                  `
                }}
              </pre>
            </div>
          </div>
          <div class="col-sm-12  mt-40 bg-secondary p-10" id="currency">
            <div class="col-sm-12">
              <h1>{{ $t("virtual_pos_api_doc.crypto_currencies") }}</h1>
            </div>
            <div>
              <div class="col-12">
                <h3>
                  <small
                    >GET--
                    {{
                      $t("virtual_pos_api_doc.crypto_currencies_desc")
                    }}:</small
                  >
                  {{ `${mpayApiBaseUrl}companies/{id}/company-wallets` }}
                </h3>
                <p
                  v-html="
                    $t('virtual_pos_api_doc.crypto_currencies_desc_2', {
                      uri: mpayApiBaseUrl
                    })
                  "
                ></p>
              </div>
              <pre class="text-white col-12 code">
                Response
                {{
                  `
                    [
                      {
                        "id": 1111,
                        "balance": "0.00",
                        "wallet": {
                            "currencyCode": "BTC",
                            "currencyName": "Bitcoin",
                            "currencyIcon": "cdnpath/btc.png",
                            "createdAt": "2024-01-21T09:07:47+00:00",
                            "updatedAt": "2024-01-21T09:07:47+00:00"
                        },
                        "createdAt": "2024-02-12T13:36:56+00:00",
                        "updatedAt": "2024-02-12T13:36:56+00:00"
                      },
                      {
                        "id": 1112,
                        "balance": "0.00",
                        "wallet": {
                            "currencyCode": "ETH",
                            "currencyName": "Ethereum",
                            "currencyIcon": "cdnpath/eth.png",
                            "createdAt": "2024-01-21T09:07:47+00:00",
                            "updatedAt": "2024-01-21T09:07:47+00:00"
                        },
                        "createdAt": "2024-02-12T13:36:56+00:00",
                        "updatedAt": "2024-02-12T13:36:56+00:00"
                      },
                      ...
                    ]
                  `
                }}
              </pre>
            </div>
          </div>
          <div class="col-sm-12 mt-40 bg-secondary p-10" id="getMe">
            <div class="col-sm-12">
              <h1>{{ $t("virtual_pos_api_doc.getMe") }}</h1>
            </div>
            <div>
              <div class="col-12">
                <h3>
                  <small
                    >GET-- {{ $t("virtual_pos_api_doc.getMe_desc") }}:</small
                  >
                  {{ `${mpayApiBaseUrl}me` }}
                </h3>
              </div>
              <pre class="text-white code col-12">
                Response
                {{
                  `
                  {
                    "parent": {
                        "id": 5,
                        "title": "Test Company Ltd.",
                        "email": "other@branch.com",
                        "taxCity": "adsdasd",
                        "taxAdministration": "dasdasd",
                        "taxNumber": "32123",
                        "hasQuickSale": false,
                        "role": {
                            "roleRank": "ROLE_BRANCH",
                            "canSubDeal": false,
                            "hasOfinansAccount": false,
                            "hasWallets": false,
                            "canSellQrCode": true
                        },
                        "isActive": true,
                        "paymentUnit": {
                            "id": 1,
                            "name": "usd"
                        },
                        "commission": 5,
                        "deletedAt": null,
                        "createdAt": "2022-01-03T10:08:50+03:00",
                        "updatedAt": "2022-07-06T20:55:19+03:00",
                        "companyRank": "BRANCH",
                        "ordersTotals": "108,422.72"
                    },
                    "posNumber": null,
                    "createdAt": "2022-01-03T10:08:50+03:00",
                    "updatedAt": "2022-09-15T15:15:58+03:00",
                    "id": 7,
                    "roles": [
                        "ROLE_BRANCH"
                    ],
                    "email": "other@branch.com",
                    "phone": "+905",
                    "firstName": "Other",
                    "lastName": "Admin",
                    "isActive": true,
                    "userRole": {
                        "roleRank": "ROLE_BRANCH",
                        "canSubDeal": false,
                        "hasOfinansAccount": false,
                        "hasWallets": false,
                        "canSellQrCode": true
                    },
                    "googleTfaEnabled": false,
                    "merchantId": 3,
                    "fullName": "Other Admin"
                  }
                  `
                }}
              </pre>
            </div>
          </div>
          <div class="col-sm-12 mt-40 bg-secondary p-10" id="deleteAddress">
            <div class="col-sm-12">
              <h1>{{ $t("virtual_pos_api_doc.delete_wallet_address") }}</h1>
            </div>
            <div>
              <div class="col-12">
                <h3>
                  <small
                    >POST--
                    {{ $t("virtual_pos_api_doc.delete_wallet_address_desc") }}:
                  </small>
                  {{ `${mpayApiBaseUrl}delete-wallet-address` }}
                </h3>
              </div>
              <pre class="col-12 code text-white">
                Request Body
                {{
                  `
                  {
                    "address": "0x4F1............",
                  }
                  `
                }}
              </pre>
              <pre class="col-12 code mt-2 text-white">
                Response
                {{
                  `
                  {
                    "success": "ok",
                    "message": "success"
                  }
                  `
                }}
              </pre>
            </div>
          </div>
          <div class="col-sm-12 mt-40 bg-secondary p-10" id="cryptoPayment">
            <h1>Crypto payment API</h1>
            <p>
              Server-to-server integration using the existing Bearer token and KYC
              checks. These endpoints do not require an additional request
              signature. Keep tokens and webhook secrets on your server, never in
              browser code. Examples use synthetic values; confirm the API host
              for your environment.
            </p>
            <ol>
              <li>Create a payment and display its address and crypto amount.</li>
              <li>
                Receive a signed final-result webhook on your branch endpoint.
              </li>
              <li>
                Query the sale if delivery is missing or the POST outcome is
                unknown.
              </li>
            </ol>
            <h2 class="mt-8">Create a payment</h2>
            <pre class="code rounded" v-pre>
  POST /api/company-orders/crypto-payment
  Authorization: Bearer YOUR_SERVER_TOKEN
  Content-Type: application/json

  {
    "merchant_order_id": "checkout-2026-001",
    "price": "120.00",
    "feeIncluded": false,
    "payment_unit": "USD",
    "currency_code": "USDTTRC",
    "customerName": "Example Customer",
    "customerMail": "customer@example.invalid",
    "customerPhone": "0000000000"
  }</pre
            >
            <p>
              Creation requires an active, KYC-approved branch user under an
              active merchant. The branch comes from the token, not the body.
              <code>merchant_order_id</code> is a nonblank string of at most 100
              characters, unique across the merchant and all its branches,
              including completed, expired and soft-deleted sales. Database
              collation controls case sensitivity; do not rely on case-only
              differences. References are mandatory only for this API creation
              channel, not legacy iframe sales.
            </p>
            <p>
              Required: reference, positive decimal-string <code>price</code> (up
              to two decimals), boolean <code>feeIncluded</code>, configured
              <code>payment_unit</code> and supported <code>currency_code</code>.
              The price plus applicable commission must stay below 100,000,000.
              Customer fields are optional strings of at most 255 characters. With
              <code>feeIncluded: false</code>, commission is added to the price.
              The example below assumes 5% commission and a synthetic 1:1 quote.
            </p>
            <pre class="code rounded" v-pre>
  HTTP/1.1 201 Created
  {
    "order_id": 123,
    "order_number": "EXAMPLE-ORDER-123",
    "merchant_order_id": "checkout-2026-001",
    "status": "pending",
    "price": "120.00",
    "fee_included": false,
    "fee_amount": "6.00",
    "order_total": "126.00",
    "payment_unit": "USD",
    "currency_code": "USDTTRC",
    "crypto_amount": "126.000000000000",
    "address": "EXAMPLE-NOT-A-PAYMENT-ADDRESS",
    "expires_at": "2026-10-02T12:30:00Z"
  }</pre
            >
            <p>
              Local sale and address records commit together or roll back
              together. External provider operations are not transactionally
              reversible. After a timeout, query the original reference before
              creating another sale. A repeated POST is not a response replay: it
              returns 409 with the existing order number and current status. Use
              GET for its details.
            </p>
            <pre class="code rounded" v-pre>
  HTTP/1.1 409 Conflict
  {
    "error": "duplicate_merchant_order_id",
    "order_number": "EXAMPLE-ORDER-123",
    "status": "pending"
  }</pre
            >
            <h2 class="mt-8" id="cryptoPaymentQuery">Query a payment</h2>
            <pre class="code rounded" v-pre>
  GET /api/company-orders/crypto-payment?merchant_order_id=checkout-2026-001
  Authorization: Bearer YOUR_SERVER_TOKEN

  GET /api/company-orders/crypto-payment?order_number=EXAMPLE-ORDER-123
  Authorization: Bearer YOUR_SERVER_TOKEN</pre
            >
            <p>
              Send exactly one query parameter, URL-encoded: a nonblank
              <code>merchant_order_id</code> (up to 100 characters) or
              <code>order_number</code> (up to 255). Active, KYC-approved branch
              and merchant users can read sales throughout their merchant,
              including sibling branches. Foreign, missing and soft-deleted sales
              return 404. Other channels can be queried by order number.
            </p>
            <p>
              A 200 response has the same fields as the 201 example, with the
              current status and <code>Cache-Control: private, no-store</code>.
              For example, after successful payment <code>status</code> is
              <code>completed</code>. Status is a string, including
              <code>pending</code>, <code>completed</code>,
              <code>underpaid</code> and <code>expired</code>; legacy intermediate
              values may also appear. Legacy reference, currency, amount, address
              or expiry fields can be null. Amounts are decimal strings, IDs are
              integers and <code>fee_included</code> is boolean.
            </p>
            <pre class="code rounded" v-pre>
  HTTP/1.1 200 OK
  Cache-Control: private, no-store
  {
    "order_id": 123,
    "order_number": "EXAMPLE-ORDER-123",
    "merchant_order_id": "checkout-2026-001",
    "status": "completed",
    "price": "120.00",
    "fee_included": false,
    "fee_amount": "6.00",
    "order_total": "126.00",
    "payment_unit": "USD",
    "currency_code": "USDTTRC",
    "crypto_amount": "126.000000000000",
    "address": "EXAMPLE-NOT-A-PAYMENT-ADDRESS",
    "expires_at": "2026-10-02T12:30:00Z"
  }</pre
            >
            <h3 class="mt-6">Errors</h3>
            <ul>
              <li>
                401: missing, invalid or expired Bearer token (existing
                authentication response).
              </li>
              <li>
                403: <code>forbidden_role</code> or
                <code>forbidden_company</code>, including inactive/KYC
                restrictions.
              </li>
              <li>404: <code>order_not_found</code> on GET.</li>
              <li>
                409: <code>duplicate_merchant_order_id</code> or an address
                allocation conflict such as <code>no_available_address</code>.
              </li>
              <li>
                422: <code>{"error":"validation_error","field":"price"}</code>;
                field identifies invalid input (or
                <code>body</code>/<code>query</code>).
              </li>
              <li>
                502: provider preparation failures, including
                <code>conversion_failed</code> or
                <code>payment_preparation_failed</code>.
              </li>
              <li>
                503: <code>payment_configuration_error</code> or
                <code>payment_creation_failed</code>.
              </li>
            </ul>
            <h2 class="mt-8" id="cryptoPaymentWebhook">Final-result webhooks</h2>
            <p>
              Configure a public HTTPS webhook URL and the existing signature
              secret for each branch through the approved operator process. There
              is no new self-service configuration endpoint or merchant-level
              fallback. Automatic completed (1) and underpaid (5) results across
              payment channels trigger events; API cron expiry (14) also triggers
              one. Manual edits, intermediate states and historical results do
              not.
            </p>
            <pre class="code rounded" v-pre>
  POST /your-payment-webhook
  Content-Type: application/json
  X-MiraclePay-Event: payment.completed
  X-MiraclePay-Event-Id: 11111111-1111-4111-8111-111111111111
  X-MiraclePay-Timestamp: 1790942520
  X-MiraclePay-Signature: v1=HEX_HMAC_SHA256

  {
    "event_id": "11111111-1111-4111-8111-111111111111",
    "event": "payment.completed",
    "occurred_at": "2026-10-02T12:02:00Z",
    "data": {
      "order_id": 123,
      "order_number": "EXAMPLE-ORDER-123",
      "merchant_order_id": "checkout-2026-001",
      "status": 1,
      "status_name": "completed",
      "branch": { "id": 3, "title": "Example Branch" },
      "device": "API",
      "fee_included": false,
      "payment_unit": "USD",
      "currency_code": "USDTTRC",
      "payment_address": "EXAMPLE-NOT-A-PAYMENT-ADDRESS",
      "tx_hash": "EXAMPLE-TRANSACTION-HASH",
      "created_at": "2026-10-02T12:00:00Z",
      "price": "120.00",
      "fee_amount": "6.00",
      "order_total": "126.00",
      "expected_crypto_amount": "126.000000000000",
      "paid_crypto_amount": "126",
      "paid_amount_converted": "126",
      "diff_crypto_amount": null,
      "diff_price": null
    }
  }</pre
            >
            <p>
              Other events are <code>payment.underpaid</code> (5 / underpaid) and
              <code>payment.expired</code> (14 / expired), using the same
              structure. All amount fields are strings or null; unknown paid
              amounts, differences, address, hash and legacy reference may be
              null. Branch is an object; device is its short code or null.
              Timestamps are UTC RFC3339; <code>created_at</code> can be null.
              Underpayment differences represent expected minus received, in
              crypto and payment-unit fiat respectively. Legacy floating-point
              fields retain their precision limitations. Customer contact
              information is not included.
            </p>
            <p>
              The full payload and event ID are saved with the result, then sent
              after commit. They do not change with later manual edits. Return a
              2xx response promptly after durable acceptance. There is at most one
              HTTP attempt: no retry, redirect, backfill or resend. DNS and HTTPS
              share a 10-second deadline. A crash, timeout, missing configuration
              or unsafe target can lose delivery; query the sale instead of
              waiting indefinitely.
            </p>
            <h3 class="mt-6">Server-side signature verification (Node.js)</h3>
            <p>
              Capture the raw request body as a Buffer before any JSON parser.
              Verify HMAC-SHA256 over the exact timestamp header, a dot, and raw
              bytes. Never verify reserialized JSON. Use the branch secret from
              server-side secure storage, not the Bearer token or a browser
              variable. Keep clocks synchronized; the accepted timestamp window is
              inclusive ±60 seconds. This verifier does not perform business
              processing.
            </p>
            <pre class="code rounded" v-pre>
  const { createHmac, timingSafeEqual } = require("crypto");

  function verifyWebhook(rawBody, headers, secret, now = Math.floor(Date.now() / 1000)) {
    const timestamp = headers["x-miraclepay-timestamp"];
    const signature = headers["x-miraclepay-signature"];
    if (!Buffer.isBuffer(rawBody) || typeof secret !== "string" || !secret) return false;
    if (typeof timestamp !== "string" || !/^\d{1,12}$/.test(timestamp)) return false;
    if (Math.abs(now - Number(timestamp)) > 60) return false;
    if (typeof signature !== "string" || !/^v1=[0-9a-f]{64}$/.test(signature)) return false;
    const expected = createHmac("sha256", secret)
      .update(timestamp + ".").update(rawBody).digest();
    return timingSafeEqual(expected, Buffer.from(signature.slice(3), "hex"));
  }</pre
            >
            <p>
              After verification, parse and validate the payload. Compare its
              event and event ID with the corresponding headers. Atomically
              deduplicate
              <code>event_id</code> in durable storage with your business update;
              acknowledge already accepted IDs without processing twice. The time
              window alone does not prevent replay. Use decimal arithmetic for
              amounts.
            </p>
            <h3 class="mt-6">Expiry and reconciliation</h3>
            <p>
              Every API crypto payment, including BTC, is eligible for expiry 30
              minutes after address creation. The first cron run after that time
              may expire a still-pending sale; the deadline is not exact to the
              second. The locked winner of payment versus expiry determines the
              result. Address cleanup happens after commit and may fail
              independently. Uncertain external transfers or address ownership
              require operator reconciliation; a local rollback is not proof of
              provider rollback.
            </p>
          </div>
          <div class="col-sm-12 mt-40 bg-secondary p-10" id="iframeApi">
            <!-- intro -->
            <div class="col-sm-12">
              <h1>
                Pay iframe<span class="text-danger">(Deprecated)</span> Migrate
                to
                <span
                  class="text-dark cursor-pointer font-weight-bold"
                  @click="scrollToView('#jsSdk')"
                  >MiraclePay JS SDK</span
                >
              </h1>
            </div>
            <div class="col-12 d-flex flex-column">
              <p
                class="text-secondary font-weight-light"
                style="font-size: large;"
              >
                Before you begin you must obtain authentication_token from
                <span
                  class="text-primary cursor-pointer font-weight-bold"
                  @click="scrollToView('#auth')"
                  >Authentication</span
                >
                section.
              </p>
              <div class="my-3 iframe-images">
                <div>
                  <img
                    :src="iframeCreateOrderImg"
                    alt=""
                    style="max-width: 250px; height: 250px; object-fit: cover;"
                    class="cursor-pointer"
                    @click="onShowImgModal(iframeCreateOrderImg)"
                  />
                </div>
                <div>
                  <img
                    :src="iframeTransactionPending"
                    alt=""
                    style="max-width: 250px; height: 250px; object-fit: cover;"
                    class="cursor-pointer"
                    @click="onShowImgModal(iframeTransactionPending)"
                  />
                </div>
                <div>
                  <img
                    :src="iframeTransactionSuccess"
                    alt=""
                    style="max-width: 250px; height: 250px; object-fit: cover;"
                    class="cursor-pointer"
                    @click="onShowImgModal(iframeTransactionSuccess)"
                  />
                </div>
                <div>
                  <img
                    :src="iframeMissingPayment"
                    alt=""
                    style="max-width: 250px; height: 250px; object-fit: cover;"
                    class="cursor-pointer"
                    @click="onShowImgModal(iframeMissingPayment)"
                  />
                </div>
                <div>
                  <img
                    :src="iframeTransactionError"
                    alt=""
                    style="max-width: 250px; height: 250px; object-fit: cover;"
                    class="cursor-pointer"
                    @click="onShowImgModal(iframeTransactionError)"
                  />
                </div>
              </div>
            </div>

            <!-- Src -->
            <div class="col-12 d-flex flex-column mb-5" id="iframeApiSrc">
              <div class="d-flex align-items-center ml-4 my-3">
                <h3 class="text-dark">Src</h3>
              </div>
              <span
                class="col-12 code overflow-auto text-white text-left rounded position-relative"
                style="font-size: small; padding: 20px 15px;"
              >
                {{ iframeUrl() }}
                <span
                  class="p-3 cursor-pointer position-absolute top-0 right-0"
                  @click="copyText(iframeUrl())"
                >
                  <i class="fa fa-clipboard"></i>
                </span>
              </span>
              <div
                class="col-12 row align-items-center"
                style="font-size: small; padding: 20px 15px;"
              >
                <b class="text-danger mr-2">IMPORTANT:</b>
                <span
                  >If <b class="text-dark">customer_email</b> parameter will be
                  used it should be used with
                  <b class="text-dark"
                    >encodeURIComponent("customer@mail.com")</b
                  >
                  method</span
                >
                (<span
                  class="text-primary font-weight-bolder cursor-pointer"
                  @click="scrollToView('#jsSdk')"
                  >Use MiraclePay JS SDK to avoid such problems.</span
                >)
              </div>
            </div>

            <!-- Variables -->
            <div class="col-12 d-flex flex-column mb-5" id="iframeApiVariables">
              <h3 class="ml-4 my-3 text-dark">Variables</h3>
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Field</th>
                      <th scope="col">Required</th>
                      <th scope="col">Type</th>
                      <th scope="col">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>token</td>
                      <td>
                        <b-icon
                          icon="check"
                          font-scale="2"
                          class="text-success"
                        ></b-icon>
                      </td>
                      <td>
                        String
                      </td>
                      <td>
                        User access token from
                        <span
                          class="cursor-pointer font-weight-bolder"
                          @click="scrollToView('#auth')"
                          >{{ `${mpayBaseUrl}authentication_token` }}</span
                        >
                        User must be in
                        <span class="font-weight-bolder">BRANCH</span> role
                      </td>
                    </tr>
                    <tr>
                      <td>order_price</td>
                      <td>
                        <b-icon
                          icon="check"
                          font-scale="2"
                          class="text-success"
                        ></b-icon>
                      </td>
                      <td>Number</td>
                      <td>
                        Order price must be numeric(can be decimal, max 2
                        digits)
                      </td>
                    </tr>
                    <tr>
                      <td>signature</td>
                      <td>
                        <b-icon
                          icon="check"
                          font-scale="2"
                          class="text-success"
                        ></b-icon>
                      </td>
                      <td>String</td>
                      <td>
                        <strong>HMAC-SHA256 signature for request integrity verification.</strong>
                        Generated from <code>order_price</code> and <code>payment_unit</code>.
                        See <span
                          class="text-primary cursor-pointer font-weight-bold"
                          @click="scrollToView('#signatureValidation')"
                        >Signature Validation</span> section.
                      </td>
                    </tr>
                    <tr>
                      <td>commission_payer</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>customer | branch</td>
                      <td>
                        Who will pay the commission in the Miraclepay side
                      </td>
                    </tr>
                    <tr>
                      <td>rt_url</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>String</td>
                      <td>
                        Redirect url after payment completed and pressed to OK
                        button in transaction success screen. If it is not
                        provided onSuccessRedirect event will be triggered. This
                        event can be listened where it's implemented the iframe
                        like below;
                        <pre class="code rounded" style="padding: 0;">

  window.addEventListener('message', function(event) {
    if(event.data?.event && event.data.event ==='onSuccessRedirect') { 
      console.log("order: " + event.data.data);
    } 
  });

</pre
                        >
                      </td>
                    </tr>
                    <tr>
                      <td>theme</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>light | dark</td>
                      <td>
                        light as default
                      </td>
                    </tr>
                    <tr>
                      <td>locale</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>en | tr</td>
                      <td>
                        en as default
                      </td>
                    </tr>
                    <tr>
                      <td>payment_unit</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>USD | GBP | TRY | EUR</td>
                      <td>
                        Not case sensitive (<strong
                          >If set, payment currency selection will be
                          disabled</strong
                        >)
                      </td>
                    </tr>
                    <tr>
                      <td>crypto</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>String</td>
                      <td>Not case sensitive</td>
                    </tr>
                    <tr>
                      <td>customer_email</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>String(email)</td>
                      <td>
                        --
                      </td>
                    </tr>
                    <tr>
                      <td>customer_name</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>String</td>
                      <td>
                        --
                      </td>
                    </tr>
                    <tr>
                      <td>customer_phone</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>String</td>
                      <td>
                        --
                      </td>
                    </tr>
                    <tr>
                      <td>auto_submit_pay_btn</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>true|false</td>
                      <td>
                        Default is <b>false</b>. If true and when
                        "<b>payment_unit</b>" and "<b>crypto</b>" params both
                        are defined then <b>"Pay with MiraclePay"</b> button
                        will be triggered automatically.
                      </td>
                    </tr>
                    <tr>
                      <td>insufficient_payment_state_extra_info_text</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>String</td>
                      <td>
                        Default is <b>null</b>. If it is wanted to add extra
                        information like "reach out customer support" in case of
                        <b>insufficient payment state</b>.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Events -->
            <div class="col-12 d-flex flex-column" id="iframeApiEvents">
              <h3 class="ml-4 my-3 text-dark">Events</h3>
              <div class="mt-3">
                <p>
                  You can listen for
                  <span class="font-weight-bolder text-dark">onSuccess</span>
                  event when <b class="text-dark">payment completed</b> has been
                  made like below:
                </p>
                <pre class="code rounded p-5" style="padding: 0;">
document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener('message', function(event) {
    if(event.data?.event && event.data.event ==='onSuccess') { 
      // <span class="text-primary cursor-pointer font-weight-bold" @click="scrollToView('#getCompanyOrder')">event.data.data: order</span>
      console.log(event.data.data);

      // your code
    } 
  });
});
</pre>
                <p>
                  And you can listen for
                  <span class="font-weight-bolder text-dark"
                    >onSuccessRedirect</span
                  >
                  event when clicked to
                  <span class="font-weight-bolder text-dark">OK button</span>
                  like below:
                </p>
                <pre class="code rounded p-5" style="padding: 0;">
document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener('message', function(event) {
    if(event.data?.event && event.data.event ==='onSuccessRedirect') {
      // your code
    } 
  });
})
</pre
                >

                <p>
                  And you can listen for
                  <span class="font-weight-bolder text-dark"
                    >onCopyWalletAddress</span
                  >
                  event when clicked to
                  <span class="font-weight-bolder text-dark">Copy button</span>
                  like below:
                </p>
                <pre class="code rounded p-5" style="padding: 0;">
document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener('message', function(event) {
    if(event.data?.event && event.data.event ==='onCopyWalletAddress') { 
      console.log("copied wallet address: " + event.data.data);
      // your code
    } 
  });
});
                </pre>

                <p>
                  In case of
                  <span class="font-weight-bolder text-dark"
                    >insufficient payment</span
                  >
                  you can listen for
                  <span class="font-weight-bolder text-dark"
                    >onInsufficientPayment</span
                  >
                  event like below:
                </p>
                <pre class="code rounded p-5" style="padding: 0;">
document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener('message', function(event) {
    if(event.data?.event && event.data.event ==='onInsufficientPayment') {
      // <span class="text-primary cursor-pointer font-weight-bold" @click="scrollToView('#getCompanyOrder')">event.data.data: order</span>
      console.log(event.data.data);
      
      // your code
    } 
  });
});
                </pre>

                <p>
                  And you can listen for
                  <span class="font-weight-bolder text-dark"
                    >onClickInsufficientOK</span
                  >
                  event when clicked to
                  <span class="font-weight-bolder text-dark"
                    >OK button in case of insufficient payment state</span
                  >
                  like below:
                </p>
                <pre class="code rounded p-5" style="padding: 0;">
document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener('message', function(event) {
    if(event.data?.event && event.data.event ==='onClickInsufficientOK') { 
      // your code
    } 
  });
});
                </pre>

                <p>
                  In case of
                  <span class="font-weight-bolder text-dark"
                    >incorrect currency payment state</span
                  >
                  you can listen for
                  <span class="font-weight-bolder text-dark"
                    >onIncorrectCurrency</span
                  >
                  event like below:
                </p>
                <pre class="code rounded p-5" style="padding: 0;">
document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener('message', function(event) {
    if(event.data?.event && event.data.event ==='onIncorrectCurrency') {
      // <span class="text-primary cursor-pointer font-weight-bold" @click="scrollToView('#getCompanyOrder')">event.data.data: order</span>
      console.log(event.data.data);
      
      // your code
    } 
  });
});
                </pre>

                <p>
                  And you can listen for
                  <span class="font-weight-bolder text-dark"
                    >onClickIncorrectCurrencyOK</span
                  >
                  event when clicked to
                  <span class="font-weight-bolder text-dark"
                    >OK button in case of incorrect currency(or network) payment
                    state</span
                  >
                  like below:
                </p>
                <pre class="code rounded p-5" style="padding: 0;">
document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener('message', function(event) {
    if(event.data?.event && event.data.event ==='onClickIncorrectCurrencyOK') { 
      // your code
    } 
  });
});
                </pre>

                <p>
                  In case of
                  <span class="font-weight-bolder text-dark"
                    >transaction error</span
                  >
                  you can listen for
                  <span class="font-weight-bolder text-dark">onError</span>
                  event like below:
                </p>
                <pre class="code rounded p-5" style="padding: 0;">
document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener('message', function(event) {
    if(event.data?.event && event.data.event ==='onError') {      
      // your code
    } 
  });
});
                </pre>

                <p>
                  In case of the page is
                  <span class="font-weight-bolder text-dark"
                    >reloaded(refreshed)</span
                  >
                  where the iframe is implemented it must be a request to
                  <span
                    class="text-primary cursor-pointer font-weight-bold"
                    @click="scrollToView('#deleteAddress')"
                    >delete wallet address endpoint</span
                  >. <br />
                  Instructions for
                  <span class="font-weight-bolder text-dark"
                    >onGetNexusPaymentAddress</span
                  >
                  event listening and how the wallet address can be stored where
                  implemented the iframe after the user clicked to
                  <span class="font-weight-bolder text-dark"
                    >Pay with Miracle Pay</span
                  >
                  button and wallet address is appeared in the UI;
                </p>
                <pre class="code rounded p-5" style="padding: 0;">
// steps to consider in your side
document.addEventListener("DOMContentLoaded", async () => {
  // 1. store wallet address in localStorage or sessionStorage
  document.addEventListener("DOMContentLoaded", () => {
    window.addEventListener('message', function(event) {
      if(event.data?.event && event.data.event ==='onGetNexusPaymentAddress') { 
        window.localStorage.setItem('wallet_address_key', event.data.data)
      } 
    });
  })

// 2. send request to delete-wallet-address and remove from storage
  const walletAddress = window.localStorage.getItem("wallet_address_key")
  if(walletAddress) {
    // post request to <span class="text-primary cursor-pointer font-weight-bold" @click="scrollToView('#deleteAddress')">delete wallet address endpoint</span>
    try {
      await window.axios.post({{ `${mpayApiBaseUrl}delete-wallet-address` }}, {
          wallet_address: mpWalletAddress
      }, { 
        headers: {
          Authorization: `Bearer <span class="text-danger font-weight-bold">access_token</span>`
        }
      });
      window.localStorage.removeItem('wallet_address_key');
    } catch (error) {
      console.error(error);
    }
  }
})
                </pre>
              </div>
            </div>
          </div>
          <div class="col-sm-12 mt-40 bg-secondary p-10" id="signatureValidation">
            <div class="col-sm-12">
              <h1>Signature Validation</h1>
            </div>
            <div class="col-12">
              <h3>Overview</h3>
              <p>
                Signature validation provides an additional layer of security for iframe payment integrations.
                It verifies that payment requests have not been tampered with during transit.
                When enabled, all iframe payment requests must include a valid HMAC-SHA256 signature.
              </p>

              <div class="alert alert-info mt-3">
                <i class="fas fa-info-circle"></i>
                <strong>Note:</strong> Signature validation applies only to <strong>Pay Iframe</strong> integration.
                MiraclePay JS SDK integration does not require signature validation.
              </div>

              <h3 class="mt-4">Generating the Signature</h3>
              <p>The signature is generated using HMAC-SHA256 with the following specification:</p>
              <table class="table table-bordered">
                <tr>
                  <td><strong>Algorithm</strong></td>
                  <td>HMAC-SHA256</td>
                </tr>
                <tr>
                  <td><strong>Secret Key</strong></td>
                  <td>Provided via secure channel (contact MiraclePay support)</td>
                </tr>
                <tr>
                  <td><strong>Message Format</strong></td>
                  <td>
                    JSON-encoded string:
                    <code
                      >{"order_price":"&lt;price&gt;","payment_unit":"&lt;unit&gt;"}</code
                    >
                  </td>
                </tr>
              </table>

              <h3 class="mt-4">Implementation Examples</h3>
              <p><strong>JavaScript / Node.js</strong></p>
              <pre class="code rounded p-3">
const crypto = require('crypto');
const data = JSON.stringify({ order_price: '600', payment_unit: 'TRY' });
const signature = crypto.createHmac('sha256', 'your-secret-key').update(data).digest('hex');
// Include in iframe URL: .../pay-sdk?token=...&order_price=600&payment_unit=TRY&signature=GENERATED_SIGNATURE
              </pre>

              <p class="mt-3"><strong>PHP</strong></p>
              <pre class="code rounded p-3">
$data = json_encode(['order_price' => '220', 'payment_unit' => 'USD']);
$signature = hash_hmac('sha256', $data, 'your-secret-key');
              </pre>

              <p class="mt-3"><strong>Python</strong></p>
              <pre class="code rounded p-3">
import hmac, hashlib, json
data = json.dumps({"order_price": "245.22", "payment_unit": "EUR"}, separators=(',', ':'))
signature = hmac.new('your-secret-key'.encode(), data.encode(), hashlib.sha256).hexdigest()
              </pre>
            </div>
          </div>
          <div class="col-sm-12 mt-40 bg-secondary p-10" id="jsSdk">
            <!-- intro -->
            <div class="col-sm-12">
              <h1>
                MiraclePay JS SDK<span class="text-success">(Recommended)</span>
              </h1>
            </div>
            <!-- Init -->
            <div class="col-12 d-flex flex-column mb-5" id="jsSdkInit">
              <div class="d-flex align-items-center my-3">
                <h3 class="text-dark">Initialization</h3>
              </div>
              <div class="position-relative rounded p-5 code">
                <pre class="text-white">
                  {{ v2HtmlContent }}
                </pre>
                <span
                  class="p-3 cursor-pointer position-absolute top-0 right-0"
                  v-if="v2HtmlContent"
                  @click="copyText(v2HtmlContent)"
                >
                  <i class="fa fa-clipboard"></i>
                </span>
              </div>
            </div>
            <!-- Props -->
            <div class="col-12 d-flex flex-column mb-5" id="jsSdkProps">
              <h3 class="my-3 text-dark">Props</h3>
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Required</th>
                      <th scope="col">Type</th>
                      <th scope="col">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>token</td>
                      <td>
                        <b-icon
                          icon="check"
                          font-scale="2"
                          class="text-success"
                        ></b-icon>
                      </td>
                      <td>
                        String
                      </td>
                      <td>
                        User access token from
                        <span
                          class="cursor-pointer font-weight-bolder"
                          @click="scrollToView('#auth')"
                          >{{ `${mpayBaseUrl}authentication_token` }}</span
                        >
                        User must be in
                        <span class="font-weight-bolder">BRANCH</span> role
                      </td>
                    </tr>
                    <tr>
                      <td>order_price</td>
                      <td>
                        <b-icon
                          icon="check"
                          font-scale="2"
                          class="text-success"
                        ></b-icon>
                      </td>
                      <td>Number</td>
                      <td>
                        Order price must be numeric(can be decimal, max 2
                        digits)
                      </td>
                    </tr>
                    <tr>
                      <td>commission_payer</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>customer | branch</td>
                      <td>
                        Who will pay the commission in the Miraclepay side
                      </td>
                    </tr>
                    <tr>
                      <td>theme</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>light | dark</td>
                      <td>
                        light as default
                      </td>
                    </tr>
                    <tr>
                      <td>locale</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>en | tr</td>
                      <td>
                        en as default
                      </td>
                    </tr>
                    <tr>
                      <td>payment_unit</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>USD | GBP | TRY | EUR</td>
                      <td>
                        Not case sensitive (<strong
                          >If set, payment currency selection will be
                          disabled</strong
                        >)
                      </td>
                    </tr>
                    <tr>
                      <td>crypto</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>String</td>
                      <td>Not case sensitive</td>
                    </tr>
                    <tr>
                      <td>customer_email</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>String(email)</td>
                      <td>
                        --
                      </td>
                    </tr>
                    <tr>
                      <td>customer_name</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>String</td>
                      <td>
                        --
                      </td>
                    </tr>
                    <tr>
                      <td>customer_phone</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>String</td>
                      <td>
                        --
                      </td>
                    </tr>
                    <tr>
                      <td>auto_submit_pay_btn</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>true|false</td>
                      <td>
                        Default is <b>false</b>. If true and when
                        "<b>payment_unit</b>" and "<b>crypto</b>" params both
                        are defined then <b>"Pay with MiraclePay"</b> button
                        will be triggered automatically.
                      </td>
                    </tr>
                    <tr>
                      <td>insufficient_payment_state_extra_info_text</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>String</td>
                      <td>
                        Default is <b>null</b>. If it is wanted to add extra
                        information like "reach out customer support" in case of
                        <b>insufficient payment state</b>.
                      </td>
                    </tr>
                    <tr>
                      <td>width</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>String | Number</td>
                      <td>
                        Payment container width. Default is "100%"
                      </td>
                    </tr>
                    <tr>
                      <td>height</td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>String | Number</td>
                      <td>
                        Payment container height. Default is "100%"
                      </td>
                    </tr>
                    <!-- function props -->
                    <tr>
                      <td>
                        onSuccess: (result:
                        <span
                          class="text-primary cursor-pointer font-weight-bold"
                          @click="scrollToView('#getCompanyOrder')"
                          >Order</span
                        >) => {}
                      </td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>
                        Function
                      </td>
                      <td>
                        Triggers after payment successfully completed.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        onClickSuccessOKButton: () => {}
                      </td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>
                        Function
                      </td>
                      <td>
                        Triggers when clicked to OK button on payment success
                        state.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        onError: (message: String) => {}
                      </td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>
                        Function
                      </td>
                      <td>
                        Triggers on error.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        onInsufficientPayment: (result:
                        <span
                          class="text-primary cursor-pointer font-weight-bold"
                          @click="scrollToView('#getCompanyOrder')"
                          >Order</span
                        >) => {}
                      </td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>
                        Function
                      </td>
                      <td>
                        Triggers after Insufficient payment state.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        onClickInsufficientOKButton: () => {}
                      </td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>
                        Function
                      </td>
                      <td>
                        Triggers when clicked to OK button on insufficient
                        payment state.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        onIncorrectCurrency: (result:
                        <span
                          class="text-primary cursor-pointer font-weight-bold"
                          @click="scrollToView('#getCompanyOrder')"
                          >Order</span
                        >) => {}
                      </td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>
                        Function
                      </td>
                      <td>
                        Triggers after Incorrect currency payment state.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        onClickIncorrectCurrencyOKButton: () => {}
                      </td>
                      <td>
                        <b-icon
                          icon="x"
                          font-scale="2"
                          class="text-danger"
                        ></b-icon>
                      </td>
                      <td>
                        Function
                      </td>
                      <td>
                        Triggers when clicked to OK button on Incorrect currency
                        payment state.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ref="modal-image-zoomed"
      hide-footer
      size="xl"
      title=""
      @hide="selectedIframeImg = null"
    >
      <div>
        <!-- <img
          :src="selectedIframeImg"
          class="img-fluid"
          style="border-radius: 10px;"
          alt=""
        /> -->
        <inner-image-zoom
          v-if="selectedIframeImg"
          :src="selectedIframeImg"
          :zoomSrc="selectedIframeImg"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/modules/breadcrumbs";
import KTBrand from "@/view/layout/brand/Brand.vue";
import { OVERRIDE_PAGE_LAYOUT_CONFIG } from "../../store/modules/config";
import InnerImageZoom from "vue-inner-image-zoom";

import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
export default {
  components: {
    KTBrand,
    "inner-image-zoom": InnerImageZoom
  },
  computed: {
    res1() {
      return require("@/assets/images/doc-images/res-1.png");
    },
    res2() {
      return require("@/assets/images/doc-images/res-2.png");
    },
    res3() {
      return require("@/assets/images/doc-images/res-3.png");
    },
    res4() {
      return require("@/assets/images/doc-images/res-4.png");
    },
    res5() {
      return require("@/assets/images/doc-images/res-5.png");
    },
    res6() {
      return require("@/assets/images/doc-images/res-6.png");
    },
    iframeCreateOrderImg() {
      return require("@/assets/images/doc-images/pay-sdk-transaction-start.png");
    },
    iframeTransactionPending() {
      return require("@/assets/images/doc-images/pay-sdk-transaction-pending.png");
    },
    iframeTransactionSuccess() {
      return require("@/assets/images/doc-images/pay-sdk-transaction-success.png");
    },
    iframeMissingPayment() {
      return require("@/assets/images/doc-images/pay-sdk-missing-payment.png");
    },
    iframeTransactionError() {
      return require("@/assets/images/doc-images/pay-sdk-transaction-error.png");
    }
  },
  data() {
    return {
      isMiracleCustomer: true,
      miracleCustomerSideTabs: [
        {
          label: this.$t("virtual_pos_api_doc.intro"),
          onClick: () => {
            this.scrollToView("#intro");
          },
          icon: "fas fa-tachometer-alt fa-fw me-3"
        },
        {
          label: "Authentication",
          onClick: () => {
            this.scrollToView("#auth");
          },
          icon: "fas fa-chart-area fa-fw me-3"
        },
        {
          label: this.$t("virtual_pos_api_doc.create_order"),
          onClick: () => {
            this.scrollToView("#createOrder");
          },
          icon: "fas fa-lock fa-fw me-3"
        },
        {
          label: this.$t("virtual_pos_api_doc.get_company_order"),
          onClick: () => {
            this.scrollToView("#getCompanyOrder");
          },
          icon: "fas fa-info fa-fw me-3"
        },
        {
          label: this.$t("virtual_pos_api_doc.convert"),
          onClick: () => {
            this.scrollToView("#convert");
          },
          icon: "fas fa-exchange-alt fa-fw me-3"
        },
        {
          label: this.$t("virtual_pos_api_doc.payment_stage"),
          onClick: () => {
            this.scrollToView("#payment_stage");
          },
          icon: "fas fa-chart-line fa-fw me-3"
        },
        {
          label: this.$t("virtual_pos_api_doc.crypto_currencies"),
          onClick: () => {
            this.scrollToView("#currency");
          },
          icon: "fas fa-coins fa-fw me-3"
        },
        {
          label: this.$t("virtual_pos_api_doc.getMe"),
          onClick: () => {
            this.scrollToView("#getMe");
          },
          icon: "fas fa-user fa-fw me-3"
        },
        {
          label: this.$t("virtual_pos_api_doc.delete_wallet_address"),
          onClick: () => {
            this.scrollToView("#deleteAddress");
          },
          icon: "fas fa-trash fa-fw me-3"
        },
        {
          label: "Crypto payment API",
          onClick: () => {
            this.scrollToView("#cryptoPayment");
          },
          icon: "fas fa-coins fa-fw me-3"
        },
        {
          label: "Pay iframe",
          onClick: () => {
            this.scrollToView("#iframeApi");
          },
          icon: "fas fa-link fa-fw me-3",
          subs: [
            {
              label: "Src",
              onClick: () => {
                this.scrollToView("#iframeApiSrc");
              }
            },
            {
              label: "Variables",
              onClick: () => {
                this.scrollToView("#iframeApiVariables");
              }
            },
            {
              label: "Events",
              onClick: () => {
                this.scrollToView("#iframeApiEvents");
              }
            },
            {
              label: "Signature Validation",
              onClick: () => {
                this.scrollToView("#signatureValidation");
              }
            }
          ]
        },
        {
          label: "mPay JS SDK",
          onClick: () => {
            this.scrollToView("#jsSdk");
          },
          icon: "fas fa-code fa-fw me-3",
          subs: [
            {
              label: "Initialization",
              onClick: () => {
                this.scrollToView("#jsSdkInit");
              }
            },
            {
              label: "Props",
              onClick: () => {
                this.scrollToView("#jsSdkProps");
              }
            }
          ]
        }
      ],
      isDev: false,
      mpayBaseUrl: "https://payapi.dev.ofinansdev.com/",
      mpayApiBaseUrl: "https://payapi.dev.ofinansdev.com/api/",
      ofinansApiBaseUrl: "https://api.dev.ofinansdev.com/v2/",
      selectedIframeImg: null,
      v2HtmlContent: null
    };
  },
  methods: {
    scrollToView(idOrClass) {
      document.querySelector(idOrClass).scrollIntoView({ behavior: "smooth" });
    },
    getCustomerDropdownText() {
      return this.isMiracleCustomer
        ? this.$t(
            "PAGES.SALES_MANAGEMENT.QR_SALE.NEW_SALE_WITH_QR_CODE.MIRACLE_CUSTOMER"
          )
        : this.$t(
            "PAGES.SALES_MANAGEMENT.QR_SALE.NEW_SALE_WITH_QR_CODE.NOT_MIRACLE_CUSTOMER"
          );
    },
    getEnvDropdownText() {
      return this.isDev ? "Development" : "Production";
    },
    onChangeEnv(isDev) {
      this.isDev = isDev;
      if (isDev) {
        this.mpayBaseUrl = "https://payapi.dev.ofinansdev.com/";
        this.mpayApiBaseUrl = "https://payapi.dev.ofinansdev.com/api/";
        this.ofinansApiBaseUrl = "https://api.dev.ofinansdev.com/v2/";
        return;
      }
      this.mpayBaseUrl = "https://api.miraclepay.com/";
      this.mpayApiBaseUrl = "https://api.miraclepay.com/api/";
      this.ofinansApiBaseUrl = "https://api.miraclecash.com/v2/";
    },
    goToSimulationLink() {
      window.open("https://sanalpos.miraclepay.ofinansdev.com/cart", "_blank");
    },
    async copyText(text) {
      await navigator.clipboard.writeText(text);
      this.$root.$bvToast.toast("Copied to clipboard.", {
        title: this.$t("COMMON.INFORM"),
        variant: "info",
        autoHideDelay: 5000
      });
    },
    onShowImgModal(imgSource) {
      this.selectedIframeImg = imgSource;
      this.$refs["modal-image-zoomed"].show();
    },
    onHideImgModal() {
      this.$refs["modal-image-zoomed"].hide();
    },
    getHost() {
      return this.isDev
        ? "https://paneldev.miraclepay.com"
        : "https://panel.miraclepay.com";
    },
    iframeUrl() {
      return `${this.getHost()}/pay-sdk?token=ey...&order_price=5&commission_payer=&rt_url=&theme=&locale=&payment_unit=&customer_name=&customer_email=&customer_phone=`;
    }
  },
  mounted() {
    this.onChangeEnv(false);
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Empty Page" }]);
    this.$store.dispatch(OVERRIDE_PAGE_LAYOUT_CONFIG, {
      aside: { self: { minimize: { toggle: false } } }
    });
    fetch("/static/mpay-js-sdk-doc.html")
      .then(res => res.text())
      .then(text => {
        this.v2HtmlContent = text;
      });
  }
};
</script>
<style>
body {
  background-color: #fbfbfb;
}
</style>

<style lang="scss" scoped>
/* Sidebar */
.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  padding: 58px 0 0; /* Height of navbar */
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 5%), 0 2px 10px 0 rgb(0 0 0 / 5%);
  width: 285px;
  z-index: 600;
}

.sidebar .active {
  border-radius: 5px;
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%);
}

.sidebar-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

@media (max-width: 991.98px) {
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
  .sidebar-sticky {
    position: relative;
    height: auto;
  }
}

@media (max-width: 1460px) and (min-width: 992px) {
  .sidebar {
    max-width: 210px;
  }
}

@media (max-width: 1200px) and (min-width: 992px) {
  .sidebar {
    max-width: 190px;
  }
}

@media (max-width: 1165px) and (min-width: 992px) {
  .sidebar {
    max-width: 170px;
  }
}

.code {
  background-color: #3f4254;
  color: white;
  padding: 20px;
}
table {
  tr {
    th {
      text-transform: uppercase;
    }
    td {
      vertical-align: middle !important;
    }
  }
}

.iframe-images {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  div {
    width: 200px;
    height: 150px;
    overflow: hidden;
    border-radius: 5px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    transition: all 0.2s ease-in-out;
  }
  div:hover {
    transform: scale(1.1);
    position: relative;
  }
}
</style>
